<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <div>
        <header>
          <ul class="HeadMain">
            <li class="HeadMainImg"><img :src="datas.product.img"></li>
            <li class="HeadMainTxt" v-text="datas.product.name"></li>
            <li class="HeadMainBox">
              <p>单元识别码</p>
              <p class="HeadMainCode"><a v-if="code" v-text="code"></a><a v-else>10191127100806341087444250870653</a></p>
            </li>
          </ul>
        </header>

        <section class="box">
          <ul class="MainBox">
            <li class="MainBoxRow" v-if="datas.product.reg_code_str">
              <p class="MainBoxLeft">登记证号：</p>
              <p class="MainBoxRight" v-text="datas.product.reg_code_str"></p>
            </li>
            <li class="MainBoxRow" v-if="datas.product.reg_code_owner">
              <p class="MainBoxLeft">登记证持有人：</p>
              <p class="MainBoxRight" v-text="datas.product.reg_code_owner"></p>
            </li>
            <li class="MainBoxRow" v-if="datas.product.alias_name">
              <p class="MainBoxLeft">农药名称：</p>
              <p class="MainBoxRight" v-text="datas.product.alias_name"></p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">保质期：</p>
              <p class="MainBoxRight" v-text="datas.product.period"></p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">规格：</p>
              <p class="MainBoxRight" v-text="datas.product.unit"></p>
            </li>
            <li class="MainBoxRow" v-if="datas.product.attribute && (val.key || val.value)" v-for="val in datas.product.attribute">
              <p class="MainBoxLeft" v-text="val.key"></p>
              <p class="MainBoxRight" v-text="val.value"></p>
            </li>
            <li class="MainBoxRow" v-if="datas.batch && datas.batch.name">
              <p class="MainBoxLeft">标签批次：</p>
              <p class="MainBoxRight" v-text="datas.batch.name"></p>
            </li>
            <div class="MainBoxRow" v-if="datas.batch && datas.batch.qc">
              <li v-for="val in datas.batch.qc">
                <p class="MainBoxLeft" v-text="val.key"></p>
                <p class="MainBoxRight" v-text="val.value"></p>
              </li>
            </div>
            <li class="MainBoxRow" v-if="datas.attribute && datas.attribute.ship_date">
              <p class="MainBoxLeft">生产日期：</p>
              <p class="MainBoxRight" v-text="datas.attribute.ship_date"></p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">查询次数：</p>
              <p class="MainBoxRight" v-text="datas.scan_count"></p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">首次查询时间：</p>
              <p class="MainBoxRight" v-text="datas.scan_first_time"></p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">首次查询地点：</p>
              <p class="MainBoxRight" v-if="datas.scan_first_address" v-text="datas.scan_first_address"></p>
              <p class="MainBoxRight" v-else>正在检测中...</p>
            </li>
            <li class="MainBoxRow">
              <p class="MainBoxLeft">追溯地址：</p>
              <p class="MainBoxRight"><a class="skip">https://sy.oid.plus</a></p>
            </li>
          </ul>
          <!-- <div class="technical">技术支持：温州链接科技有限公司</div> -->
        </section>
      </div>

    </div>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Pesticide01',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      count:2,
      datas:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      Music:{
        url:null,
        type:false
      }
    }
  },
  created () {
    self = this;

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

    document.title = "农药二维码追溯系统";  //设置页面标题
    document.body.style.backgroundColor = "#DCF4DC";
  },
  updated () {

  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){
        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点

        //针对天津市农药研究所企业特殊处理
        if(datas.business && datas.business.rootid === '100010117'){
          const oneRuls = [132431839000003, 132431634000003, 132431413000003];
          const twoRuls = [132431188000003, 132436823000003];
          if(oneRuls.indexOf(response.data.meta.plan_id) !== -1){
            self.code = self.replaceAt(self.code, 7, 2);
          }
          if(twoRuls.indexOf(response.data.meta.plan_id) !== -1){
            self.code = self.replaceAt(self.code, 7, 1);
          }
        }

        //自定义属性
        if(response.data.meta.activation_a){
          datas.attribute = JSON.parse(response.data.meta.activation_a);
        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //产品自定义属性
        if (datas.product.attribute) {
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }
        //企业自定义属性
        if (datas.business.customize_data) {
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //根据批次修改-河南欣农
        if(response.data.meta.activation_id == '108206739000004'){
          datas.product.name = '浙小霜';
          datas.product.alias_name = '47%烯酰.吡唑酯悬浮剂';
          datas.product.reg_code_owner = '海南力智生物工程有限责任公司';
          datas.product.attribute = [{key:'受托生产企业名称', value:'江西浙农化工有限公司'}];
        }

        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    replaceAt(string, index, replacement) {
        if (index >= string.length) {
            return string.concat(replacement);
        } else {
            return string.substring(0, index) + replacement + string.substring(index + 1);
        }
    }
  }
}
</script>

<style scoped>
  header{
    overflow: hidden;
    background-color: #1ca464;
  }
  .HeadMain{
    display: table;
    margin:.5rem auto;
  }
  .HeadMainImg{
    width: 5rem;
    margin:0 auto;
  }
  .HeadMainImg img{
    display: table;
    width: 100%;
  }
  .HeadMainTxt{
    text-align: center;
    margin-top:.5rem;
    font-size:.65rem;
    color:#FFF;
  }
  .HeadMainBox{
    color:#FFF;
    margin-top:.5rem;
    border:1px solid #FFF;
    text-align: center;
    padding:.3rem .8rem;
    font-size:.58rem;
  }
  .HeadMainCode{
    margin-top:.3rem;
  }
  .box{
    overflow: hidden;
    background-color: #dcf4dc;
  }
  .MainBox{
    margin:.5rem;
    background-color: #FFF;
    border:1px solid #E3E3E3;
  }
  .MainBoxRow{
    font-size: .58rem;
    overflow: hidden;
    line-height: .8rem;
    border-bottom: 1px solid #E3E3E3;
  }
  .MainBoxRow:last-child{
    border-bottom: 0;
  }
  .MainBoxLeft{
    float: left;
    padding:.5rem;
    width: 4.5rem;
    color:#444;
  }
  .MainBoxRight{
    float: left;
    border-left: 1px solid #E3E3E3;
    padding:.5rem;
    width: calc(100% - 7rem);
  }
  .technical{
    text-align: center;
    font-size:.52rem;
    color:#555;
    margin-bottom: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide01.vue